import React, { useState, useEffect } from 'react';
import { DrawerBody, Drawer } from '@one-thd/sui-atomic-components';
import { MenuItems } from './MenuItems';
import { TConcreteRouteGroup } from '../../models/navigation';
import { MWDrawerHeader } from './MWDrawerHeader';

export const NavigationDrawerContent = ({
  concreteRouteGroups,
  open,
  onClose,
}: {
  concreteRouteGroups: TConcreteRouteGroup[];
  open: boolean;
  onClose: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const [isSubmenu, setIsSubmenu] = useState<boolean>(false);
  const [menuTitle, setMenuTitle] = useState<string | null>(null);
  const currentMenu: TConcreteRouteGroup[] = concreteRouteGroups;

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const setDrawerToDefaultState = () => {
    setMenuTitle(null);
    setIsSubmenu(false);
  };

  const toggleDrawer = () => {
    setIsOpen((prevValue) => {
      if (prevValue) {
        onClose();
      }
      return !prevValue;
    });
  };

  const onClick = (label: string | null) => {
    if (label) {
      setMenuTitle(label);
      setIsSubmenu(true);
    }
  };

  return (
    <Drawer
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        onClose();
      }}
      position="right"
      fixed
    >
      <MWDrawerHeader
        setDrawerToDefaultState={setDrawerToDefaultState}
        isSubmenu={isSubmenu}
        toggleDrawer={toggleDrawer}
        menuTitle={menuTitle}
      />
      <DrawerBody className="sui-overflow-y-auto sui-bg-primary sui-shrink sui-basis-auto sui-grow sui-border-solid sui-border-primary sui-border-t-1">
        <MenuItems
          menu={currentMenu}
          currentMenuTitle={menuTitle}
          isSubmenu={isSubmenu}
          onClick={onClick}
        />
      </DrawerBody>
    </Drawer>
  );
};
